import { MetaView, useTable, withTable } from '@oscar/table';
import { Space } from '@oscar/theme';
import { PageHeader } from 'common/components';
import { APIS } from 'common/constants/endpoints';
import React from 'react';
import {
  columnsServiceProvider,
  transReqServiceProvider,
  transResServiceProvider,
} from 'views/pages/utils';
import SearchTool from './components/SearchTool';
// import './style.scss';

const Table = withTable({
  name: 'service-provider',
  keyField: 'id',
  mode: 'REMOTE',
  request: {
    name: 'service-provider',
    url: APIS.SEARCH_SERVICES_PROVIDER,
    method: 'POST',
    transformRequest: transReqServiceProvider,
    transformResponse: transResServiceProvider,
  },
  columns: columnsServiceProvider,
});

function ServiceProvider() {
  const [table] = useTable();

  return (
    <div className="request-list">
      <PageHeader title="Service Provider" subtitle="Manage Service Provider" />

      <div className="main-request-list">
        <MetaView table={table}>
          {(childProps: any) => (
            <SearchTool
              actionTable={childProps?.table}
              metadata={childProps?.metadata}
            />
          )}
        </MetaView>

        <Space size={[16, 16]} direction="vertical" className="space-table">
          <Table key="service-provider" rowKey="id" table={table} />
        </Space>
      </div>
    </div>
  );
}

export default ServiceProvider;
